export enum ContactSubscriptionsStatusEnum {
  active = 'active',
  cancelled = 'cancelled',
}

export enum ContactSubscriptionsStatusTitleEnum {
  cancelled = 'global.cancelled',
  active = 'global.active',
}
